import { useEffect, useState } from 'react';
import AOS from 'aos';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqs = [
  {
    question: 'How long does a project take?',
    answer: 'Project timelines vary based on complexity. A simple landing page may take 1-2 weeks, while a full-stack web application can take 4-12 weeks. I provide detailed estimates after understanding your requirements.',
  },
  {
    question: 'Do you provide deployment and hosting support?',
    answer: 'Yes, I can help set up and deploy your website on reliable cloud platforms like AWS, Vercel, Netlify, or DigitalOcean. I also provide guidance on choosing the right hosting plan for your needs.',
  },
  {
    question: 'Can you redesign my existing website?',
    answer: 'Absolutely! I can modernize your existing website while preserving your brand identity. Whether you need a UI refresh or a complete overhaul, I deliver designs that improve user experience and conversions.',
  },
  {
    question: 'Do you provide maintenance?',
    answer: 'Yes, I offer ongoing maintenance packages that include security updates, performance optimizations, bug fixes, and content updates. This ensures your website stays secure and performs optimally.',
  },
  {
    question: 'What is your payment process?',
    answer: 'I typically work with a 40% upfront deposit, 30% at mid-project milestone, and 30% upon completion. For smaller projects, I accept 50% advance and 50% on delivery. Payment methods include bank transfer & PhonePay.',
  },
  {
    question: 'Will the website be mobile responsive?',
    answer: 'Yes, all my websites are fully responsive and tested across devices including smartphones, tablets, laptops, and desktops. Mobile-first design ensures optimal experience on all screen sizes.',
  },
  {
    question: 'Can I request additional features later?',
    answer: 'Of course! I build scalable applications that can grow with your business. Additional features can be discussed and implemented in future phases. I maintain clean codebase making future enhancements seamless.',
  },
];

const FAQSection = () => {

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <section className="faq-section" id="faq" style={{ background: '#f9f9f9' }}>
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="service-section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Find answers to common questions about my services and process.
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="accordion" id="faqAccordion" data-aos="fade-up" data-aos-delay="100">
              {faqs.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header m-0">
                    <button
                      className={`accordion-button d-flex justify-content-between align-items-center w-100 ${
                        activeIndex === index ? "active" : ""
                      }`}
                      type="button"
                      onClick={() => setActiveIndex(activeIndex === index ? -1 : index)}
                    >
                      <span>{faq.question}</span>
                      <span className="faq-icon mr-3" >
                        {activeIndex === index ? <FaMinus size={15} /> : <FaPlus size={15} />}
                      </span>
                    </button>
                  </h2>
                  {activeIndex === index && (
                    <div className="accordion-body">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
